import Vue from "vue";
import axios from 'axios';
import Qs from 'qs';
import {url} from './location.js';
Vue.prototype.ajaxUrl = url;
export const getAjax = function (target,url,data){
	let _that=this;
	return new Promise((resolve) => {
		_that.axios.post(_that.ajaxUrl(target,url), Qs.stringify(
			data
		) ).then((res) => {
			resolve(res);
		})
	})
}